export default __webpack_public_path__ + "static/media/Sporthilfe_Logo_Teamsuisse_DE_RGB-1024x461.84cd02fd.png";